import * as React from 'react'
import Img from './Img'
import CTALink from './CTALink'
import clsx from 'clsx'

import iconCaution from 'assets/icons/icon-caution.svg'
import iconCone from 'assets/icons/icon-cone.svg'
import iconDrill from 'assets/icons/icon-drill.svg'
import iconHook from 'assets/icons/icon-hook.svg'
import iconHome from 'assets/icons/icon-home.svg'
import iconMeasure from 'assets/icons/icon-measure.svg'
import iconPlan from 'assets/icons/icon-plan.svg'
import iconPurifier from 'assets/icons/icon-purifier.svg'
import iconSaw from 'assets/icons/icon-saw.svg'
import iconStar from 'assets/icons/icon-star.svg'
import iconTools from 'assets/icons/icon-tools.svg'
import iconWorker from 'assets/icons/icon-worker.svg'

const getIcon = (icon) => {
	switch (icon) {
		case 'caution':
			return iconCaution
		case 'cone':
			return iconCone
		case 'drill':
			return iconDrill
		case 'hook':
			return iconHook
		case 'home':
			return iconHome
		case 'measure':
			return iconMeasure
		case 'plan':
			return iconPlan
		case 'purifier':
			return iconPurifier
		case 'saw':
			return iconSaw
		case 'star':
			return iconStar
		case 'tools':
			return iconTools
		case 'worker':
			return iconWorker
		default:
			return false
	}
}

export default function IconAndText({
	icon,
	image,
	title,
	children,
	link,
	className,
}) {
	return (
		<div className={clsx('space-y-4 text-balance <md:mx-auto', className)}>
			{image && (
				<figure className="h-[60px] w-auto">
					<Img
						className="aspect-square h-full"
						image={image}
						objectFit="contain"
					/>
				</figure>
			)}

			{!!getIcon(icon) && (
				<img className="h-[60px]" src={getIcon(icon)} alt={title} />
			)}

			<h3 className="h2">{title}</h3>

			{children && <p className="leading-relaxed">{children}</p>}

			{link?.url && <CTALink {...link} />}
		</div>
	)
}
